const APIS = {
  COA: "/accountingservice/api/account/",
  BILL: "/accountingservice/api/bill/",
  JOURNAL_ENTRY: "/accountingservice/api/journal-entry/",
  COMPANY_PROFILE: "/accountingservice/api/company-profile/",
  STAFF: "/logisticservice/api/staff/",
  LEDGER_GROUP: "/accountingservice/api/ledger-group/",
  ACCOUNT_INFO: "/accountingservice/api/account-info/",
  SUB_LEDGER: "/accountingservice/api/sub-ledger/",
  AGENT: "/accountingservice/api/agent/",
  USER: "/accountingservice/api/party/",
  USER_PROFILE: "/logisticservice/api/user-profile/",
  CLIENT_TYPE: "/logisticservice/api/client-type/",
  TRANSACTION: "/accountingservice/api/transaction/",
  GENERAL_LEDGER: "/accountingservice/api/general-ledger/",
  PRODUCT: "/accountingservice/api/product/",
  SALES_PURCHASE: "/accountingservice/api/sales-purchase/",
  SALES_PURCHASE_RETURN: "/accountingservice/api/sales-purchase-return/",
  GRID_REPORT_DATA_COURIER: "/projectsettingsservice/api/courier-grid-report/",
  GRID_REPORT_DATA_LOGISTIC:
    "/projectsettingsservice/api/logistic-grid-report/",
  STATUS: "/logisticservice/api/status/",
  CLIENT_SETTING: "/projectsettingsservice/api/configuration/",
  ORDER: "/logisticservice/api/order/",
  BRANCH: "/usermanagementservice/api/branch/",
  BALANCE_SHEET: "/accountingservice/api/balance-sheet/",
  CATEGORY: "/productservice/api/category/",
  UNIT: "/productservice/api/unit/",
  TRIAL_BALANCE: "/accountingservice/api/trial-balance/",
  TYPES: "/accountingservice/api/account/types/",
  OVERVIEW: "/accountingservice/api/bill/overview/",
  NUMBER_SERIRES: "/accountingservice/api/number-series/",
  CREATE_USER: "/accountingservice/api/party/",
  PROFIT_LOSS: "/accountingservice/api/profit-loss/",
  BILL_PRINT: "/accountingservice/api/bill/print/",
  DAILY_NOTE:"/accountingservice/api/daily-note/"
} as const;

export default APIS;
